import { RoomType, StyleType, Project, CreditPack, StagingCost } from "@/types";

export const roomTypes: RoomType[] = [
  {
    id: "living-room",
    name: "Obývací pokoj",
    image: "https://s3.amazonaws.com/aihomedesign/space/57483926-23e7-4813-863c-0426a583f294.svg",
  },
  {
    id: "bedroom",
    name: "Ložnice",
    image: "https://s3.amazonaws.com/aihomedesign/space/0aca0a7f-6eef-4d9d-821c-48091c1d5d0b.svg",
  },
  {
    id: "kitchen",
    name: "Kuchyně",
    image: "https://s3.amazonaws.com/aihomedesign/space/cc45796c-5731-48de-84e8-0f946e6ade8d.svg",
  },
  {
    id: "dining-room",
    name: "Jídelna",
    image: "https://s3.amazonaws.com/aihomedesign/space/c07f8658-d3fa-4137-9a43-c191d0e0e954.svg",
  },
  {
    id: "bathroom",
    name: "Koupelna",
    image: "https://s3.amazonaws.com/aihomedesign/space/715cb5e5-c9c3-44fd-80cb-d34be1adee8a.svg",
  },
  {
    id: "office",
    name: "Pracovna",
    image: "https://s3.amazonaws.com/aihomedesign/space/49d6dead-12d1-4866-9b90-59e0acd5f229.svg",
  },
];

export const styleTypes: StyleType[] = [
  {
    id: "modern",
    name: "Moderní",
    image: "/images/styles/modern.jpg",
  },
  {
    id: "scandinavian",
    name: "Skandinávský",
    image: "/images/styles/scandi.jpg",
  },
  {
    id: "rustic",
    name: "Rustikální",
    image: "/images/styles/rustic.jpeg",
  },
  {
    id: "minimalistic",
    name: "Minimalistický",
    image: "/images/styles/minimal.jpg",
  },
  {
    id: "industrial",
    name: "Industriální",
    image: "/images/styles/industry.jpg",
  },
  {
    id: "bohemian",
    name: "Bohémský",
    image: "/images/styles/bohem.jpg",
  },
];

export const mockProjects: Project[] = [
  {
    id: "1",
    userId: "123",
    originalImageUrl: "/placeholder.svg",
    stagedImageUrl: "/placeholder.svg",
    roomType: "living-room",
    styleType: "modern",
    status: "completed",
    createdAt: new Date().toISOString(),
  },
  {
    id: "2",
    userId: "123",
    originalImageUrl: "/placeholder.svg",
    roomType: "bedroom",
    styleType: "scandinavian",
    status: "processing",
    createdAt: new Date().toISOString(),
  },
];

export const creditPacks: CreditPack[] = [
  {
    id: "basic",
    name: "Basic Pack",
    credits: 5,
    price: 9.99,
  },
  {
    id: "standard",
    name: "Standard Pack",
    credits: 15,
    price: 24.99,
  },
  {
    id: "premium",
    name: "Premium Pack",
    credits: 50,
    price: 74.99,
  },
];

export const stagingCosts: StagingCost[] = [
  {
    id: "1",
    service: "Virtual Staging",
    creditCost: 1,
  },
];
